import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { getLabelsForMultipleDeliveries } from "../services/deliveryService";
import handleApiError from "../helpers/handleApiError";
import PDFObject from "pdfobject";
import { defaultTitle } from "../config";
import { Helmet } from "react-helmet";
import { isClient } from "../services/accountService";
// import { sleep } from "../helpers/utilities";

const viewStates = {
  success: "success",
  loading: "loading",
  nodata: "nodata",
  error: "error",
};
const LabelViewer = ({ setLoading }) => {
  const { id } = useParams();
  const history = useHistory();
  const [viewState, setViewState] = useState(viewStates.loading);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setViewState(viewStates.loading);

      try {
        const { data } = await getLabelsForMultipleDeliveries(
          "" + id,
          false,
          isClient()
        );
        // await sleep(31000);
        setViewState(viewStates.success);
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          PDFObject.embed(reader.result, "#pdf-container");
          setLoading(false);
        };
      } catch (ex) {
        setViewState(viewStates.error);
        setLoading(false);
        handleApiError(ex, history);
      }
    })();
  }, [id, history, setLoading]);

  return (
    <div>
      <Helmet>
        <title>View Labels - {defaultTitle}</title>
      </Helmet>

      <div
        id="pdf-container"
        style={{
          height: viewState === viewStates.success ? "100vh" : "0",
          backgroundColor: "rgb(82,86,89)",
        }}
      ></div>
      {viewState === viewStates.loading && (
        <div
          style={{
            height: "100vh",
            backgroundColor: "rgb(82,86,89)",
            color: "white",
            display: "grid",
            placeContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div className="spinner-border p-3 m-2" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <br />
            Retrieving Labels
          </div>
        </div>
      )}
      {viewState === viewStates.error && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "grid",
            placeContent: "center",
          }}
        >
          There was an error retrieving label for this order. Please make sure
          the order has not been voided and you are connected to the internet.
        </div>
      )}
    </div>
  );
};

export default LabelViewer;
